import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
// JSON-LD (schema.org) wstrzykiwany do <head>. Dziala takze w SSR -
// crawlery (Google, LLM-y) dostaja dane strukturalne bez wykonywania JS.
// Schematy per-page sa czyszczone przy kazdej nawigacji; globalne
// (Organization/WebSite) zyja przez caly czas.
const ATTR = 'data-sc-schema';
export class SchemaService {
    constructor(document, router) {
        this.document = document;
        this.router = router;
        this.router.events
            .pipe(filter(e => e instanceof NavigationStart))
            .subscribe(() => this.clearPageSchemas());
    }
    /** Schemat globalny - nie jest czyszczony przy nawigacji. */
    setGlobal(id, schema) {
        this.set(`global-${id}`, schema);
    }
    /** Schemat strony - znika przy przejsciu na inna trase. */
    setForPage(id, schema) {
        this.set(`page-${id}`, schema);
    }
    clear(id) {
        const existing = this.document.head.querySelector(`script[${ATTR}="page-${id}"], script[${ATTR}="global-${id}"]`);
        if (existing) {
            existing.remove();
        }
    }
    set(key, schema) {
        let script = this.document.head.querySelector(`script[${ATTR}="${key}"]`);
        if (!script) {
            script = this.document.createElement('script');
            script.setAttribute('type', 'application/ld+json');
            script.setAttribute(ATTR, key);
            this.document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(Object.assign({ '@context': 'https://schema.org' }, schema));
    }
    clearPageSchemas() {
        const scripts = this.document.head.querySelectorAll(`script[${ATTR}^="page-"]`);
        for (let i = 0; i < scripts.length; i++) {
            scripts[i].remove();
        }
    }
}
SchemaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SchemaService_Factory() { return new SchemaService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i2.Router)); }, token: SchemaService, providedIn: "root" });
